import { graphql } from "lib/generated/app-service-gql";
import { SupplierMentionType } from "lib/types/graphQLEnums";
import { useGraphQlQuery } from "../useGraphQlClient";

const buyerSupplierAwardStatsQuery = graphql(`
  query buyerSupplierAwardStats(
    $buyerGuid: String!
    $supplierGuid: String!
    $supplierMentionType: NoticeTopicSearchInput_Filters_SupplierMentionTypeEnum_0
    $publishedFrom: String
  ) {
    buyerSupplierAwardStats(
      buyerGuid: $buyerGuid
      supplierGuid: $supplierGuid
      supplierMentionType: $supplierMentionType
      publishedFrom: $publishedFrom
    ) {
      noticeCount
      latestAwardDate
      awardValue
    }
  }
`);

/**
 * Notice count for one buyer and supplier under a mention type, plus the value and latest date of
 * the awards that name the supplier, all from `publishedFrom` (YYYY-MM-DD) when it's given.
 */
export function useBuyerSupplierAwardStats(
  buyerGuid: string,
  supplierGuid: string,
  supplierMentionType: SupplierMentionType,
  publishedFrom?: string,
  options?: { enabled?: boolean; retry?: boolean },
) {
  const { data, ...rest } = useGraphQlQuery(
    ["buyerSupplierAwardStats", buyerGuid, supplierGuid, supplierMentionType, publishedFrom],
    buyerSupplierAwardStatsQuery,
    [{ buyerGuid, supplierGuid, supplierMentionType, publishedFrom }],
    options,
  );

  return { data: data?.buyerSupplierAwardStats, ...rest };
}
